import React from 'react';
import { graphql, ChildProps } from 'react-apollo';
import gql from 'graphql-tag';
import { CoreSiteBannerHero } from '../../schemas/rql';
import SiteBannerHero from '@reverbdotcom/commons/src/cms/components/site_banner_hero';

export function SiteBannerHeroContainer({ data }: ChildProps<{}, CoreSiteBannerHero.Query>) {
  if (data?.loading) {
    return null;
  }
  return (
    <SiteBannerHero siteBanner={data.siteBanner} />
  );
}

const withQuery = graphql<CoreSiteBannerHero.Query>(
  gql`
    query Core_SiteBannerHero {
      siteBanner {
        id
        heading
        subheading
        callToAction
        url {
          href
        }
        hasPhotos
        imageUrl
        contentSponsorship {
          sponsorshipType
          partnershipName
        }
      }
    }
  `,
);

export default withQuery(SiteBannerHeroContainer);
